export type TimeCategory = 'all' | 'weekly' | 'monthly' | 'yearly';
export type WeeklySubCategory = 'all' | 'hit-price' | 'above-below' | 'price-range';

type QuestionType =
  | 'yearly-hit-price'
  | 'yearly-best-month'
  | 'monthly-hit-price'
  | 'weekly-hit-price'
  | 'weekly-above-below'
  | 'weekly-price-range';

export interface MarketOutcome {
  id: string;
  label: string;
  probability: number;
  volume: number;
  yesPrice: number;
  noPrice: number;
}

export interface PredictionMarket {
  id: string;
  commodityId: string;
  commodityName: string;
  commodityImage: string;
  commodityTicker: string;
  question: string;
  questionType: QuestionType;
  timeCategory: Exclude<TimeCategory, 'all'>;
  weeklySubCategory?: WeeklySubCategory;
  outcomes: MarketOutcome[];
  totalVolume: number;
  endDate: string;
  isLive: boolean;
}

export interface ProbabilityDataPoint {
  timestamp: string;
  label: string;
  values: Record<string, number>;
}

export const TIME_CATEGORIES: { key: TimeCategory; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'weekly', label: 'Weekly' },
  { key: 'monthly', label: 'Monthly' },
  { key: 'yearly', label: 'Yearly' },
];

export const WEEKLY_SUB_CATEGORIES: { key: WeeklySubCategory; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'hit-price', label: 'Hit Price' },
  { key: 'above-below', label: 'Above / Below' },
  { key: 'price-range', label: 'Price Range' },
];

export const QUESTION_TO_WEEKLY_SUB: Record<string, WeeklySubCategory> = {
  'weekly-hit-price': 'hit-price',
  'weekly-above-below': 'above-below',
  'weekly-price-range': 'price-range',
};
